import styled from "styled-components"
import "./hero.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebook,
  faYoutube,
  faDiscord,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons"
import { faHourglassStart, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { useUser } from "../../context/useUser"
import SignUpForm from "../auth/SignUpForm"
import LoginForm from "../auth/LoginForm"
import ReactModal from "../common/ReactModal"
import { useState } from "react"

const Component = ({ image, title, sub, text }) => {
  const { user } = useUser()

  // Self-contained modal state
  const [openLogin, setOpenLogin] = useState(false)
  const [showLogin, setShowLogin] = useState(false)
  const toggleModal = () => setOpenLogin(!openLogin)
  const toggleLogin = () => setShowLogin(!showLogin)

  // When Sign Up is clicked, open modal and show sign up form
  const handleClickSignUp = () => {
    if (!user) {
      setOpenLogin(true)
      setShowLogin(false)
    }
  }

  return (
    <>
      <Hero id="hero" className=" px-3 ">
        {/* <h1 className="fs-1 mb-3 hero-title heading  ">{title}</h1>
        <p className="fs-5 hero-subtitle lead">{text}</p> */}

        {/* </div>{" "} */}
        <div className="col col-md-6 d-flex align-items-center justify-content-center">
          <div></div>
          {/* </div>
          </div> */}
        </div>
        <div className="container">
          <div className="row py-5">
            <div className="col-lg-1 d-none d-lg-flex align-items-center justify-content-center">
              <div
                className="lc-block d-flex"
                style={{
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                }}
              >
                <Button
                  className="btn btn-link my-2  text-decoration-none"
                  href="https://www.facebook.com/groups/1304744652991863"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faFacebook}
                    inverse
                    fixedWidth
                    style={{ color: "white", transform: "rotate(90deg)" }}
                    className="ms-1"
                    role="button"
                  />{" "}
                  Facebook
                </Button>
                <Button
                  className="btn btn-link my-4  text-decoration-none"
                  href="https://www.tiktok.com/@vgc.es"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faTiktok}
                    inverse
                    fixedWidth
                    style={{ color: "white", transform: "rotate(90deg)" }}
                    className="ms-1"
                    role="button"
                  />{" "}
                  TikTok
                </Button>
                <Button
                  className="btn btn-link my-2  text-decoration-none"
                  href="https://www.youtube.com/channel/UCPDPALfTJQg1TRL8cPxgb4g"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faYoutube}
                    inverse
                    fixedWidth
                    style={{ color: "white", transform: "rotate(90deg)" }}
                    className="ms-1"
                    role="button"
                  />{" "}
                  Youtube
                </Button>
              </div>
            </div>
            <div className="col-sm-6 d-flex d-lg-none flex-sm-column align-items-center justify-content-around mb-4 mb-sm-0">
              <div className="lc-block">
                <Button
                  className="btn btn-link text-light text-decoration-none "
                  href="https://www.facebook.com/groups/1304744652991863"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faFacebook}
                    inverse
                    fixedWidth
                    style={{ color: "white" }}
                  />{" "}
                  Facebook
                </Button>
              </div>
              <div className="lc-block">
                <Button
                  className="btn btn-link  text-decoration-none"
                  href="https://www.tiktok.com/@vgc.es"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faTiktok}
                    inverse
                    fixedWidth
                    style={{ color: "white" }}
                  />{" "}
                  TikTok
                </Button>
              </div>
              <div className="lc-block">
                <Button
                  className="btn btn-link  text-decoration-none"
                  href="https://www.youtube.com/channel/UCPDPALfTJQg1TRL8cPxgb4g"
                  role="button"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faYoutube}
                    inverse
                    fixedWidth
                    style={{ color: "white" }}
                  />{" "}
                  Youtube
                </Button>
              </div>
            </div>
            {/* hero image */}
            <div className="col-lg-4 col-sm-6 d-flex align-items-center justify-content-center">
              <div className="lc-block ratio ratio-1x1 ">
                <Img
                  style={{ objectFit: "cover" }}
                  className="img-fluid"
                  src={image}
                  alt="Photo of VCG logo."
                ></Img>
              </div>
            </div>
            <div className="col-lg-4 offset-lg-1">
              <div className="lc-block my-5">
                  <h2 className="rfs-25 display-4  heading">{title}</h2>
              </div>
              <div className="lc-block my-5">
                  <p className="">{text}</p>
              </div>
              <div className="lc-block">
                {/* <a className="btn btn-primary btn-lg" href="#" role="button">
                  Contact Us
                </a> */}
                <a className="btn btn-info btn-lg me-2" role="button" onClick={handleClickSignUp} >
                  <FontAwesomeIcon icon={faHourglassStart} className="me-2" /> Sign Up
                </a>
                <a className="btn btn-light btn-lg" href="https://discord.gg/E7X8PBUe3t" role="button" target="_blank">
                  <FontAwesomeIcon
                    icon={faDiscord}
                    inverse
                    fixedWidth
                    style={{ color: "#00eaff" }}
                  />
                  {' '}Discord
                </a>
                {/* <a
                  href="#"
                  className="hero-button primary-button "
                  onClick={handleClickSignUp}
                >
                  Sign Up
                </a>
                <a
                  href="https://discord.gg/ManYKfKMsN"
                  target="_blank"
                  className="hero-button secondary-button"
                >
                  Join Us{" "}
                  <span>
                    <FontAwesomeIcon
                      icon={faDiscord}
                      inverse
                      fixedWidth
                      style={{ color: "black" }}
                    />
                  </span>
                </a> */}
              </div>
              <div className="d-flex gap-2"></div>
            </div>
          </div>
        </div>
      </Hero>

      {/* login/sign up modal (self-contained, using ReactModal) */}
      <ReactModal
        modalOpen={openLogin}
        closeModal={toggleModal}
        component={
          showLogin ? (
            <LoginForm
              toggleModal={toggleModal}
              modalOpen={openLogin}
              toggleLogin={toggleLogin}
            />
          ) : (
            <SignUpForm
              toggleModal={toggleModal}
              modalOpen={openLogin}
              toggleLogin={toggleLogin}
            />
          )
        }
      />
    </>
  )
}
export default Component
const Hero = styled.div`
  min-height: 100vh;
  /* background-color: #1a1a1f; */
  white-space: pre-wrap;
  /* background-color: rgb(38, 38, 38); */
  font-size: 16px;
  /* background: linear-gradient(to bottom, #212529, #1a1a1f); */
  /* background-color: black; */
  background: transparent;
`
const Img = styled.img`
  border-radius: 8px;
  @media (max-width: 567px) {
  }
`
const Button = styled.a`
  border: none;
  text-decoration: none;
  color: white;
  &:focus,
  &:hover {
    border: none;
    outline: none;
    color: white;
    box-shadow: none;
  }
`
